module.exports = __webpack_public_path__ + "static/media/appointment.8b32bf3d.svg";